import "./membershipListCard.scss";

import BenefitsSwiper from "./BenefitsSwiper";
import Typography from "../../../../../../common/Typography";
import BankNote04 from "../../../../../../assets/BankNote04";
import ArrowNarrowLeft from "../../../../../../assets/ArrowNarrowLeft";
import { formatNumber } from "../../../../../../../utils/constants/constants";

const MembershipListCard = ({ currMemb, setCurrMemb, currencyView }) => {
  const membership = currMemb?.membership;
  const textColor = membership?.landing_page_settings?.colors?.text ?? "#000";
  const themeColor =
    membership?.landing_page_settings?.colors?.theme ?? "#FFCA05";

  const membPrice = formatNumber(membership?.subscription_details?.price);
  const amntSaved = formatNumber(
    membership?.subscription_details?.customer_saves_on_purchase
  );

  const totalBenefitsPrice = membPrice + amntSaved;

  const handleCardClick = () => {
    window.scrollTo(0, 0);
    setCurrMemb(currMemb);
  };

  return (
    <div
      onClick={handleCardClick}
      className="membership-list-card"
      style={{
        backgroundColor: themeColor,
        backgroundImage: `url('/assets/images/membership/gift_box.webp')`,
      }}
    >
      <div className="customer-saves-row">
        <div
          className="customer-saves-chip"
          style={{
            backgroundColor: textColor,
          }}
        >
          <img
            width={16}
            height={16}
            alt="party-popper-icon"
            src="/assets/icons/party-popper.svg"
          />
          <Typography
            size="text-sm"
            weight="medium"
            customClass="customer-saves-chip-text"
            style={{
              color: themeColor,
            }}
          >
            Save {currencyView}
            {amntSaved}
          </Typography>
        </div>
        <div
          className="arrow-div"
          style={{
            backgroundColor: textColor,
          }}
        >
          <ArrowNarrowLeft
            width={16}
            height={16}
            rotate={180}
            color={themeColor}
          />
        </div>
      </div>
      <Typography
        weight="medium"
        size="display-lg"
        customClass="membership-name"
        style={{
          color: textColor,
        }}
      >
        {membership?.landing_page_settings?.title}
      </Typography>
      <hr className="divider" />
      <BenefitsSwiper membership={membership} rewards={currMemb?.rewards} />
      <div className="benefit-details-card">
        <div className="bundle-benefit-card">
          <div className="bundle-benefit-card-head">
            <BankNote04 color={textColor} />
            <Typography
              size="heading-sm"
              style={{
                color: textColor,
              }}
            >
              Benefits worth {currencyView}
              {totalBenefitsPrice}
            </Typography>
          </div>
          <Typography
            weight="medium"
            size="display-lg"
            customClass="bundle-benefit-card-subtitle"
            style={{
              color: textColor,
            }}
          >
            for only {currencyView}
            {membPrice}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default MembershipListCard;
